export default __webpack_public_path__ + "static/media/self-serving-saas-tool-image.1276a403.png";